import { render, staticRenderFns } from "./TransferStudents.vue?vue&type=template&id=49f1f5f4"
import script from "./TransferStudents.vue?vue&type=script&lang=js"
export * from "./TransferStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports